import InitCancellationsLogic from "./Cancellations.logic";
import { formatDateTime, formatBookingLongDate, formatBookingTime } from "../../helpers/dateFormat";

// "2026-09" -> "09.2026."
const monthLabel = (m: string) => {
    const [y, mo] = m.split("-");
    return `${mo}.${y}.`;
};

const SummaryList: React.FC<{ title: string; items: any[]; monthChosen: boolean }> = ({ title, items, monthChosen }) => (
    <div style={{ marginTop: 8 }}>
        <p className="sectionLabel" style={{ fontWeight: 600, opacity: 0.7, margin: "8px 0 4px" }}>{title}</p>
        {items.length === 0 && <p style={{ opacity: 0.6, fontSize: "0.9rem", margin: 0 }}>Nema podataka.</p>}
        {items.map((it) => (
            <div key={it.id ?? it.name} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: "1px solid var(--border)", fontSize: "0.92rem" }}>
                <span>{it.name}</span>
                <span style={{ opacity: 0.85 }}>
                    {monthChosen && <>izabrano: <b>{it.selected}</b>, </>}ukupno: <b>{it.total}</b>
                </span>
            </div>
        ))}
    </div>
);

const CancellationsComponent: React.FC = () => {
    const { summary, rows, month, setMonth, loading } = InitCancellationsLogic();
    const monthChosen = !!month;

    return (
        <div className="page-container">
            <h1 className="text-align-center">Otkazivanja</h1>

            <div style={{ marginTop: 8 }}>
                <label htmlFor="month">Mesec</label>
                <select id="month" value={month} onChange={(e) => setMonth(e.target.value)}>
                    <option value="">Sve (od početka)</option>
                    {(summary.months ?? []).map((m: string) => (
                        <option key={m} value={m}>{monthLabel(m)}</option>
                    ))}
                </select>
            </div>

            <div className="card" style={{ marginTop: 16 }}>
                <SummaryList title="Po klijentima" items={summary.byClient ?? []} monthChosen={monthChosen} />
            </div>
            <div className="card" style={{ marginTop: 12 }}>
                <SummaryList title="Po trenerima" items={summary.byTrainer ?? []} monthChosen={monthChosen} />
            </div>

            <p className="sectionLabel" style={{ fontWeight: 600, opacity: 0.7, margin: "20px 0 4px" }}>
                Poslednja otkazivanja
            </p>

            {loading && <p style={{ textAlign: "center", opacity: 0.6, marginTop: 12 }}>Učitavanje...</p>}
            {!loading && rows.length === 0 && (
                <p style={{ textAlign: "center", opacity: 0.6, marginTop: 12 }}>Nema otkazivanja.</p>
            )}

            <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: 8 }}>
                {rows.map((r) => (
                    <div className="card" key={r.id}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <p style={{ fontWeight: 600, margin: 0 }}>{r.client}</p>
                            {r.trial && (
                                <span style={{ fontSize: "0.75rem", padding: "2px 8px", borderRadius: 8, background: "var(--warning-bg)", color: "var(--warning-text)" }}>
                                    probni
                                </span>
                            )}
                        </div>
                        <div style={{ marginTop: 8, fontSize: "0.9rem", display: "flex", flexDirection: "column", gap: 4 }}>
                            <div>
                                <span style={{ opacity: 0.7 }}>Otkazano: </span>
                                {r.cancelledAt ? formatDateTime(r.cancelledAt) : "-"}
                            </div>
                            <div>
                                <span style={{ opacity: 0.7 }}>Termin: </span>
                                {r.bookingDate ? `${formatBookingLongDate(r.bookingDate)} u ${formatBookingTime(r.bookingDate)}` : "-"}
                                {r.location ? `, ${r.location}` : ""}
                            </div>
                            <div>
                                <span style={{ opacity: 0.7 }}>Trener: </span>
                                {r.trainer ?? "nije označen"}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default CancellationsComponent;
